export interface SearchOption<TModel, TId> {
    id: TId;
    text: string;
    dropText: string;
    itemSource: TModel;
}